import { toast } from 'react-toastify';

const toastInfo = (render: any) => {
  toast.dismiss();
  toast.clearWaitingQueue();
  toast.info(render, { updateId: '1' });
};
const toastWarning = (render: any) => {
  toast.dismiss();
  toast.clearWaitingQueue();
  toast.warning(render, { updateId: '1' });
};

export { toastInfo, toastWarning };
